export default __webpack_public_path__ + "static/media/monero.b32d9794.svg";